export default __webpack_public_path__ + "static/media/DNo.29-2.ebfc2259.jpg";